import React, { useState, useEffect } from 'react';
import { Col, Container, Image, Row } from "react-bootstrap";
import CircularProgress from "../../components/common/CircularProgress";
import { storage } from '../../config/fbConfig';
import { ref, getDownloadURL } from 'firebase/storage';
import { Link } from 'react-router-dom';

/**
 * ProjectNewsComponent - Renders the list of project partners.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.news - The list of news
 *
 * @returns {JSX.Element} The rendered component.
 */
const ProjectNewsComponent = ({ news }) => {
    const [currentPage, setCurrentPage] = useState(1);

    if (!news)
        return (<CircularProgress />);

    const itemsPerPage = 3;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = news.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(news.length / itemsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };



    return (
        <>
            <Row>
                <h4>Related News ({news.length} items):</h4>
                {currentItems.map(newsItem => (
                    <Col key={newsItem.id} xs={12} sm={6} md={6} lg={4} >
                        <ProjectNewsItem newsItem={newsItem} />
                    </Col>
                ))}
            </Row>
            <Row className='mb-5'>
                <Col>
                    <div className="pagination-controls">
                        <button onClick={handlePrevious} disabled={currentPage === 1}>Previous</button>
                        <span>{" "+ currentPage} / {totalPages + " "}</span>
                        <button onClick={handleNext} disabled={currentPage === totalPages}>Next</button>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default ProjectNewsComponent;


const ProjectNewsItem = ({ newsItem }) => {

    const [featuredImageUrl, setFeaturedImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const logoPathAndFile = 'news/thumb_' + newsItem.featuredImage;

    useEffect(() => {

        const getDownloadUrl = async () => {
            try {
                const imageRef = ref(storage, logoPathAndFile);
                const url = await getDownloadURL(imageRef);
                setFeaturedImageUrl(url);
                setIsLoading(false);
            } catch (error) {
                console.error('Error getting download URL:', error);
                setIsLoading(false);
            }
        };

        if (newsItem.featuredImage)
            getDownloadUrl();

    }, [newsItem.featuredImage]); // Run this effect when logoPath changes

    return (
        <div>
            <div style={{ position: 'relative', width: '192px', height: '108px' }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    {isLoading && (<CircularProgress />)}
                </div>
                <Image
                    src={featuredImageUrl}
                    width={192}
                    height={108}
                    thumbnail
                />
            </div>
            <small className="text-muted" style={{ textAlign: 'right' }}>{newsItem.created?.toDate?.()?.toLocaleDateString?.() ?? ''}</small>
            <p>
                <Link to={`/news/${newsItem.slug}`}>
                    {newsItem.title}</Link>
            </p>

        </div>

    );
}